import clsx from "clsx";
import { Icon } from "@/ui/icon/Icon";
import { RadioIcon } from "@/ui/icon/icons/radio-icon/RadioIcon";
import type { Calc } from "../../types";
import styles from "./CalculatorPaymentMethod.module.css";

export const CalculatorPaymentMethod: React.FC<
  Calc.Payment.Method & {
    onChange?: () => void;
  }
> = ({ type, active, title, text, onChange }) => {
  return (
    <div
      className={clsx(styles.paymentMethod, active && styles.active)}
      onClick={onChange}
    >
      <RadioIcon className={styles.radio} active={active} />
      <div className={styles.title}>{title}</div>
      {text !== undefined && <div className={styles.text}>{text}</div>}
      <PaymentMethodIcon type={type} />
    </div>
  );
};

const PaymentMethodIcon: React.FC<{
  type: Calc.Payment.Type;
}> = ({ type }) => {
  switch (type) {
    case "card":
      return <Icon className={styles.icon} name="card_24px_semibold" />;
    case "apple-pay":
      return (
        <Icon
          className={styles.icon}
          name="apple_pay_40_32px"
          width={40}
          height={32}
        />
      );
    case "google-pay":
      return (
        <Icon
          className={styles.icon}
          name="google_pay_40_32px"
          width={40}
          height={32}
        />
      );
    case "pix":
      return <Icon className={styles.icon} name="pix_payment_24px" />;
    case "paypal":
      return <Icon className={styles.icon} name="paypal_24px_semibold" />;
    case "crypto":
      return <Icon className={styles.icon} name="bitcoin_24px_regular" />;
  }
};
